import script from "./NoteTypeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteTypeForm.vue?vue&type=script&setup=true&lang=js"

import "./NoteTypeForm.vue?vue&type=style&index=0&id=9922e3f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9922e3f4"]])

export default __exports__